import { useAuth } from "@/services/userService"
import { Link } from "@/router"

export default function NoAccount() {

    const { auth, logoutHandler } = useAuth()

    return (
        <div className="sm:py-8 h-screen">
            <div className="sm:mx-auto sm:w-full sm:max-w-lg sm:rounded-xl sm:border sm:border-gray-500 bg-white shadow-xl p-2 flex flex-col">
                <div>
                    <img
                        className="mx-auto h-10 w-auto"
                        src="/wsfr.png"
                        alt="Simple React App"
                    />
                    <h2 className="mt-4 text-center text-2xl font-bold leading-9 tracking-tight text-gray-9000" lang="fr">
                        Compte non trouvé
                    </h2>
                </div>
                <div className="mt-10 text-center flex flex-col gap-3" lang="fr">
                    <p>Il semblerait que vous n&apos;ayez pas encore de compte pour cette application.</p>
                    <p>Si vous pensez que c&apos;est une erreur, veuillez contacter Worldskills France ou votre correspondant régional.</p>
                    {
                        auth && auth.fromIdp && (
                            <button 
                                className="py-2 px-2 border border-blue-500 hover:bg-blue-600 hover:text-white rounded-md" 
                                onClick={() => logoutHandler()}
                                lang="fr"
                            >Se déconnecter</button>
                        )
                    }
                    {
                        auth && !auth.fromIdp && (
                            <Link to="/logout" className="py-2 px-2 border border-blue-500 hover:bg-blue-600 hover:text-white rounded-md" lang="fr">Se déconnecter</Link>
                        )
                    }
                </div>
            </div>
        </div>
    )
}